import { useTitle } from '@/hooks/useTitle';
import styles from './styles.module.scss';

export function LegalPage() {
  useTitle('DienTEA | Aviso Legal');

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h1>Aviso Legal</h1>
          <p className={styles.subtitle}>Última actualización: mayo de 2026</p>
        </header>

        <section className={styles.section}>
          <h2>1. Datos identificativos del titular</h2>
          <p>
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
            Información y del Comercio Electrónico (LSSI-CE), se facilitan los siguientes datos:
          </p>
          <div className={styles.dataBlock}>
            <div className={styles.dataRow}>
              <span className={styles.dataKey}>Titular</span>
              <span className={styles.dataVal}>María Pilar Pecci Lloret</span>
            </div>
            <div className={styles.dataRow}>
              <span className={styles.dataKey}>NIF / CIF</span>
              <span className={styles.dataVal}>48618310J</span>
            </div>
            <div className={styles.dataRow}>
              <span className={styles.dataKey}>Domicilio</span>
              <span className={styles.dataVal}>
                Av. Marqués de Los Velez, s/n, 30008 Murcia. Hospital Universitario Morales Meseguer. 1 planta. Despacho
                1.25.
              </span>
            </div>
            <div className={styles.dataRow}>
              <span className={styles.dataKey}>Correo electrónico</span>
              <span className={styles.dataVal}>
                <a href='mailto:contacto@dientea.es'>contacto@dientea.es</a>
              </span>
            </div>
            <div className={styles.dataRow}>
              <span className={styles.dataKey}>Sitio web</span>
              <span className={styles.dataVal}>https://dientea.es</span>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <h2>2. Objeto y ámbito de aplicación</h2>
          <p>
            El presente Aviso Legal regula el acceso y uso del sitio web, cuya finalidad es ofrecer a familias un
            espacio con vídeos seleccionados y recursos visuales sobre la primera visita al dentista, con especial
            atención a niños con Trastorno del Espectro Autista (TEA).
          </p>
          <p>
            El acceso a este sitio web es gratuito y no requiere registro previo. El mero acceso implica la aceptación
            del presente Aviso Legal, así como de la <a href='/politica-de-privacidad'>Política de Privacidad</a> y la{' '}
            <a href='/politica-de-cookies'>Política de Cookies</a>.
          </p>
        </section>

        <section className={styles.section}>
          <h2>3. Propiedad intelectual e industrial</h2>
          <p>
            Todos los contenidos del sitio web —incluyendo, sin carácter limitativo, textos, pictogramas, imágenes,
            diseño gráfico, estructura y código fuente— son titularidad de sus autoras o han sido debidamente
            licenciados, y están protegidos por la legislación española e internacional en materia de propiedad
            intelectual e industrial.
          </p>
          <p>
            Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación total o
            parcial de dichos contenidos sin autorización escrita previa de las titulares, salvo que la ley lo permita
            expresamente.
          </p>
          <p>
            Los vídeos incrustados en el sitio son contenido de terceros alojado en YouTube (Google LLC). Los derechos
            sobre dichos vídeos corresponden a sus respectivos autores o creadores.
          </p>
        </section>

        <section className={styles.section}>
          <h2>4. Carácter informativo del contenido</h2>
          <div className={styles.notice}>
            <strong>Nota importante:</strong> Los contenidos de este sitio web tienen una finalidad exclusivamente
            informativa y educativa. No constituyen diagnóstico clínico, prescripción médica ni sustitución de la
            atención odontopediátrica profesional. Ante cualquier duda sobre la salud bucodental de su hijo/a, consulte
            siempre con un especialista.
          </div>
        </section>

        <section className={styles.section}>
          <h2>5. Limitación de responsabilidad</h2>
          <p>
            Las titulares del sitio web no se hacen responsables de los daños o perjuicios que pudieran derivarse del
            uso de los contenidos o de la imposibilidad de acceder al sitio.
          </p>
          <p>
            Asimismo, no se garantiza la ausencia de virus u otros elementos dañinos en los contenidos que puedan causar
            alteraciones en los sistemas informáticos de los usuarios.
          </p>
          <p>
            Los vídeos de YouTube están sujetos a la disponibilidad del servicio y a las condiciones de uso de Google
            LLC. Las titulares no controlan los cambios que YouTube pueda realizar sobre dichos contenidos.
          </p>
        </section>

        <section className={styles.section}>
          <h2>6. Política de enlaces</h2>
          <p>
            El sitio web puede contener enlaces a páginas de terceros. Estos enlaces se facilitan únicamente con fines
            informativos y no implican ningún tipo de respaldo, patrocinio o responsabilidad sobre los contenidos
            enlazados.
          </p>
          <p>
            Cualquier persona que desee establecer un enlace hacia este sitio deberá solicitar autorización previa por
            escrito a las titulares.
          </p>
        </section>

        <section className={styles.section}>
          <h2>7. Legislación aplicable y jurisdicción</h2>
          <p>
            El presente Aviso Legal se rige por la legislación española. Para cualquier controversia derivada del acceso
            o uso del sitio web, las partes se someten a los Juzgados y Tribunales del domicilio del titular,
            renunciando expresamente a cualquier otro fuero que pudiera corresponderles.
          </p>
        </section>

        <section className={styles.section}>
          <h2>8. Contacto</h2>
          <p>
            Para cualquier consulta relativa al presente Aviso Legal, puede contactarnos en{' '}
            <a href='mailto:contacto@dientea.es'>contacto@dientea.es</a>.
          </p>
        </section>
      </div>
    </main>
  );
}
